import { Component, HostListener } from '@angular/core'
import { EbStorefrontComponent } from './components/storefront/eb-storefront.component'

@Component({
  selector: 'eb-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [EbStorefrontComponent]
})
export class AppComponent {
  title = 'eb-storefront'

  @HostListener('document:click', ['$event'])
  defocusButtonsAfterClick(event: MouseEvent): void {
    // event.detail contains the number of mouseclicks within short amount of time before the current event.
    // when click was triggered by keyboard this number is 0
    if (event.detail > 0 && event.target) {
      const element = event.target as HTMLElement

      const tagNameLower = element.tagName?.toLowerCase()
      if (tagNameLower === 'button' || tagNameLower === 'a') {
        element.blur()
      } else {
        element.closest<HTMLElement>('button, a')?.blur()
      }
    }
  }
}
